import React from "react";
import "./style.scss";

const BlogSpinner = (params) => (<div className="blog-loader"></div>)

export default BlogSpinner;